import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationChallengeGroupGoalNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M12 5a2 2 0 100 4 2 2 0 000-4z" />
        <path d="M12 1C4.654 1 .924 3.777.407 4.193A1.092 1.092 0 000 5.046V13c0 3.965 3.026 6.685 5.766 8.35 2.792 1.698 5.639 2.521 5.941 2.607a1.08 1.08 0 00.586 0c.302-.086 3.149-.909 5.941-2.606C20.974 19.685 24 16.965 24 13V5.045c0-.31-.132-.63-.407-.852C23.076 3.777 19.345 1 12 1zM2 13V5.506C3.019 4.82 6.265 3 12 3s8.981 1.82 10 2.506V13a5.5 5.5 0 01-.335 1.888L18.6 10.8l1.921.56.56-1.92-4.8-1.4A1 1 0 0015 9v5h2v-1.999l3.587 4.782c-.876 1.11-2.08 2.062-3.392 2.859-1.553.944-3.136 1.597-4.195 1.98V18l1.2 1.6 1.6-1.2-3-4a1 1 0 00-1.6 0l-3 4 1.6 1.2L11 18v3.622c-1.06-.383-2.642-1.036-4.195-1.98-1.311-.797-2.516-1.748-3.392-2.859L7 12.001V14h2V9a1 1 0 00-1.28-.96l-4.8 1.4.56 1.92L5.4 10.8l-3.066 4.088A5.501 5.501 0 012 13z" />
      </g>
    </svg>
  )
);
SvgNavigationChallengeGroupGoalNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationChallengeGroupGoalNormalSmall;
